import { Icon } from "@qw/ui";
import { useInboxRail } from "@/inbox/use-inbox-rail";
import { BookRow } from "./book-row";
import { BOOK_ROW_GUTTER_CLASSNAME, BookRowGutter } from "./book-row-gutter";
import { useBookItemForInsured } from "./use-book-item-for-insured";

/**
 * The insured the Book is standing in front of, held at the top of the panel for
 * as long as the Back-to-book pin keeps it out of the merged rail.
 *
 * The Book's own row idiom rather than a header control: the broker left from
 * this insured, so the way back should look like the thing being gone back to,
 * carrying `aria-current` the way that insured's row carries it everywhere else.
 * It sits above `ColumnContent` rather than inside it so scrolling the Book
 * cannot take the way back with it.
 *
 * A button, not the `InsuredLink` the rows below it use. `InsuredLink` navigates
 * to `/inbox/:insuredId`, and a bare path drops `?conversationId=` — which would
 * close the email the pin exists to keep open. Releasing the pin puts the insured
 * back in the rail and leaves the URL alone.
 */
export const SelectedInsuredRow = () => {
  const { isInsuredHeldByPin, railInsuredId, railInsuredName, returnToInsured } = useInboxRail();
  const bookItem = useBookItemForInsured(railInsuredId);

  if (!isInsuredHeldByPin) {
    return null;
  }

  // `mx-1` matches `ColumnListContent`'s `px-1`, so this lines up with the rows
  // below it rather than sitting a few pixels out from them.
  return (
    <BookRow className="mx-1 mb-1 grid-cols-[1fr]">
      <button
        aria-current
        className="group grid cursor-pointer grid-cols-[--spacing(18)_1fr] items-center gap-3 pl-1 text-left text-xs"
        onClick={returnToInsured}
        type="button"
      >
        {/* The insured's own row out of the Book, so this leads with the same state
            icon and date it carries in the column. `domain` — the search dropdown's
            icon for an insured — only stands in when the Book is not showing this
            insured at all: filtered out by the year range, by `showExpired`, or
            simply not in the broker's book. There is no row to match then. */}
        {bookItem ? (
          <BookRowGutter item={bookItem.item} variant={bookItem.variant} />
        ) : (
          <span className={BOOK_ROW_GUTTER_CLASSNAME}>
            <Icon icon="domain" />
          </span>
        )}
        <span className="truncate">{railInsuredName ?? "Selected insured"}</span>
      </button>
    </BookRow>
  );
};
